import React from 'react';
import { Trash01 } from '@opendate-app/setlist';
import { CLEAR_HOLD_ATTRIBUTE } from './clearHold';

const ClearHoldTrigger = () => (
  <span className="hold-event-clear" {...{ [CLEAR_HOLD_ATTRIBUTE]: 'true' }} title="Clear hold">
    <Trash01 width={12} height={12} aria-hidden="true" />
  </span>
);

ClearHoldTrigger.propTypes = {};

export default ClearHoldTrigger;
